import { render, staticRenderFns } from "./BroadcastSchedules.vue?vue&type=template&id=ddd9fc2a&scoped=true"
import script from "./BroadcastSchedules.vue?vue&type=script&lang=js"
export * from "./BroadcastSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd9fc2a",
  null
  
)

export default component.exports